import { useEffect, useState } from "react";
import styles from "./Users.module.css";
import { flashAlert } from "../global_js";
import Button from "./Button";
import AddUserModal from "../modals/AddUserModal";

function Users() {
  const restLocations = JSON.parse(sessionStorage.getItem("locations"));
  const [users, setUsers] = useState([]);
  const [rowInEdit, setRowInEdit] = useState("");
  const [resetUserRow, setResetUserRow] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("userLogin")).userId;

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    //Deactive edit mode if selected
    if (rowInEdit) {
      deactivateInput(rowInEdit);
    }

    const result = await fetch("/api/users");
    if (!result.ok) {
      flashAlert("Error fetching data", "error");
      return;
    }
    const data = await result.json();
    setUsers(data);
  };

  const updateUserSelect = (row, el) => {
    const newUser = users[row];
    const newUsers = [...users];
    switch (el.target.name) {
      case "Active":
        newUsers[row] = { ...newUser, active: el.target.value === "false" ? false : true };
        break;
      case "Admin":
        newUsers[row] = { ...newUser, isAdmin: el.target.value === "false" ? false : true };
        break;
      case "Location":
        newUsers[row] = { ...newUser, LocationID: el.target.value };
        break;
    }
    setUsers(newUsers);
  };

  const rowEditMode = (row) => {
    setResetUserRow(users);
    setRowInEdit(row);
    const ctlInputs = document.querySelectorAll(`#data${row} input`);
    const ctlSelects = document.querySelectorAll(`#data${row} select`);
    ctlInputs.forEach((ctl) => {
      ctl.removeAttribute("readOnly");
      ctl.classList.add(styles.editMode);
    });
    ctlSelects.forEach((ctl) => {
      ctl.removeAttribute("disabled");
      ctl.classList.add(styles.editMode);
    });
    document.getElementById(`group${row}`).classList.add(styles.editing);
    document.getElementById(`button${row}`).classList.add(styles.remove);
  };

  const saveUser = async (row) => {
    const submitData = users[row];
    await fetch("/api/users", {
      method: "put",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submitData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.code) {
          flashAlert("The user did not save. Error: " + data.code, "error");
        } else {
          flashAlert("User Saved", "success");
          deactivateInput(rowInEdit, 1);
          getUsers();
        }
      });
  };

  const updateUserFirstName = (row, el) => {
    const newUser = users[row];
    const newUsers = [...users];
    newUsers[row] = { ...newUser, FirstName: el.value };
    setUsers(newUsers);
  };
  const updateUserLastName = (row, el) => {
    const newUser = users[row];
    const newUsers = [...users];
    newUsers[row] = { ...newUser, LastName: el.value };
    setUsers(newUsers);
  };
  const updateUsername = (row, el) => {
    const newUser = users[row];
    const newUsers = [...users];
    newUsers[row] = { ...newUser, Username: el.value };
    setUsers(newUsers);
  };
  const updateUserEmail = (row, el) => {
    const newUser = users[row];
    const newUsers = [...users];
    newUsers[row] = { ...newUser, Email: el.value };
    setUsers(newUsers);
  };

  const deactivateInput = (row, isSave = 0) => {
    if (!isSave) {
      setUsers(resetUserRow);
    }
    const ctlInputs = document.querySelectorAll(`#data${row} input`);
    const ctlSelects = document.querySelectorAll(`#data${row} select`);
    ctlInputs.forEach((ctl) => {
      ctl.setAttribute("readOnly", true);
      ctl.classList.remove(styles.editMode);
      ctl.value = ctl.defaultValue;
    });
    ctlSelects.forEach((ctl) => {
      ctl.setAttribute("disabled", true);
      ctl.classList.remove(styles.editMode);
    });
    document.getElementById(`group${row}`).classList.remove(styles.editing);
    document.getElementById(`button${row}`).classList.remove(styles.remove);
  };

  return (
    <section className={styles.userList}>
      <div className={styles.userHeader}>
        <h2>User Management</h2>
        <AddUserModal restLocations={restLocations} getUsers={getUsers} />
      </div>
      <div className={styles.userTableDiv}>
        <table className={styles.userTable}>
          <thead>
            <tr>
              <th className={styles.textLeft}>First name</th>
              <th className={styles.textLeft}>Last name</th>
              <th className={styles.textLeft}>Username</th>
              <th className={styles.textLeft}>Email</th>
              <th className={styles.textCenter}>Location</th>
              <th className={styles.textCenter}>Is Admin</th>
              <th className={styles.textCenter}>Last login</th>
              <th className={styles.textCenter}>Active</th>
              <th className={styles.textCenter}></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              return (
                <tr id={`dataRow-${user.idUsers}`}>
                  <td className={styles.textLeft}>
                    <input
                      type="text"
                      value={user.FirstName}
                      className={`${styles.userInput}`}
                      onChange={(e) => updateUserFirstName(index, e.target)}
                      readOnly
                    />
                  </td>
                  <td className={styles.textLeft}>
                    <input
                      type="text"
                      value={user.LastName}
                      className={`${styles.userInput}`}
                      onChange={(e) => updateUserLastName(index, e.target)}
                      readOnly
                    />
                  </td>
                  <td className={styles.textLeft}>
                    <input
                      type="text"
                      value={user.Username}
                      className={`${styles.userInput}`}
                      onChange={(e) => updateUsername(index, e.target)}
                      readOnly
                    />
                  </td>
                  <td className={styles.textLeft}>
                    <input
                      type="text"
                      value={user.Email}
                      className={`${styles.userInput}`}
                      onChange={(e) => updateUserEmail(index, e.target)}
                      readOnly
                    />
                  </td>
                  <td className={styles.textCenter}>
                    <select
                      className={styles.userSelect}
                      value={user.LocationID}
                      name="Location"
                      onChange={(e) => updateUserSelect(index, e)}
                      disabled
                    >
                      {restLocations.length > 1 && <option value={0}>All</option>}
                      {restLocations.map((rest) => {
                        return <option value={rest.idLocation}>{rest.Description}</option>;
                      })}
                    </select>
                  </td>
                  <td className={`${styles.textCenter} ${styles.width5}`}>
                    <select className={styles.userSelect} value={user.isAdmin} name="Admin" onChange={(e) => updateUserSelect(index, e)} disabled>
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </td>
                  <td className={`${styles.textCenter} ${styles.width8}`}>
                    {user.LastLogin && new Date(user.LastLogin.slice(0, -1)).toDateString()}
                  </td>
                  <td className={`${styles.textCenter} ${styles.width5}`}>
                    <select className={styles.userSelect} value={user.active} name="Active" onChange={(e) => updateUserSelect(index, e)} disabled>
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </td>
                  <td className={`${styles.textCenter} ${styles.width5}`}>
                    <Button
                      type="pOutline"
                      id={`buttonRow-${user.idUsers}`}
                      onClick={() => {
                        rowEditMode(`Row-${user.idUsers}`);
                      }}
                    >
                      Edit
                    </Button>
                    <div id={`groupRow-${user.idUsers}`} className={styles.saveButtonGroup}>
                      <i className={`fa-solid fa-floppy-disk ${styles.saveIcon}`} onClick={() => saveUser(index)}></i>
                      <i
                        className={`fa-solid fa-xmark ${styles.closeIcon}`}
                        onClick={() => {
                          //setEventData({ ...eventData, Deposit: tempInputValue });
                          deactivateInput(`Row-${user.idUsers}`);
                        }}
                      ></i>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default Users;
